import request from 'utils/request';

export default async function fetchDealDetails(
  index = 1,
  limit = 10,
  filter = {}
): Promise<any> {
  try {
    const { data: result } = await request(`/lineDriveService/dealDetails`, {
      method: 'GET',
      body: {
        index: index - 1,
        limit,
        ...filter
      }
    });

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
